import * as React from 'react';

import FileImage32 from './FileImage32';

export const fileImage32 = () => <FileImage32 />;

export default {
    title: 'Icon/Content/FileImage32',
    component: FileImage32,
    parameters: {
        notes: "`import FileImage32 from 'box-ui-elements/es/icon/content/FileImage32';`",
    },
};
